import "bootstrap/dist/css/bootstrap.min.css"
import "./app.css";
import "./index.css";
import ManagerContent from "./ManagerContent";
import {BrowserRouter} from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {useEffect, useState} from "react";
import Login from "./pages/Login/Login";
import Loading from "./component/Loading/Loading";
import {isManagerLoggedIn, isReporterLoggedIn} from "./pages/Login/functions";
import ReporterContent from "./ReporterContent";

function App() {
    const [isLoading , setIsLoading] = useState(true);

    const [isManagerAuthorized , setIsManagerAuthorized] = useState(false);
    const [isReporterAuthorized , setIsReporterAuthorized] = useState(false);

    useEffect(() => {
        (async () => {
            const managerLoggedIn = await isManagerLoggedIn();
            const reporterLoggedIn = await isReporterLoggedIn ();
            if (managerLoggedIn) {
                setIsManagerAuthorized(true);
                setIsReporterAuthorized(false);
            }
            else if (reporterLoggedIn){
                setIsManagerAuthorized(false);
                setIsReporterAuthorized(true);
            }
            setIsLoading(false);
        })();

    } , []);

    if (isLoading)
        return <Loading />

    return (
        <BrowserRouter basename="/application">
            <ToastContainer />
            {isManagerAuthorized && <ManagerContent/>}
            {isReporterAuthorized && <ReporterContent/>}
            {!isManagerAuthorized && !isReporterAuthorized && <Login />}
        </BrowserRouter>
    );
}

export default App;
